<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Tier Help</h6>
    </d-card-header>

    <d-card-body class="p-0">
        <p class="ml-3 mr-3 mt-2 mb-1"> We highly recommend adding an emoji!</p>
        <img class="screenshot" src="https://givemagic.s3.us-east-2.amazonaws.com/Admin+Panel+Assets/Help+Screenshots/Screen+Shot+2019-08-21+at+8.17.02+PM.png">
    </d-card-body>
  </d-card>
</template>

<script>
export default {
  name: 'sidebar-actions',
  props: {
    /**
     * The component's title.
     */

  },
};
</script>
